import { ScreenDevicePage } from '@hq/screen-scan';
import { useNavigate } from 'react-router-dom';
import { hq } from '../session';

/**
 * 大屏设备（SYSTEM 门户）：所有租户的大屏总表。
 * 取数凭据只有一条路径——大屏显示 12 位申请码 → 在电脑端「申请码确认」填入 →
 * 屏端领取「设备凭据」（可逐屏吊销）。旧「大屏密钥」通道已下线（密钥要写进屏的静态配置且无法逐屏吊销）。
 */
export default function ScreenDevices() {
  const navigate = useNavigate();

  return (
    <ScreenDevicePage
      hq={hq}
      platform
      showPending
      canDisable
      title="全部大屏"
      onScan={() => navigate('/system/screen-scan')}
      onOpenScreen={() => window.open('/screen', '_blank')}
    />
  );
}
